import HelpScout from './HelpScout';
export default new HelpScout();
export { MESSAGE_TYPES, NOTIFICATION_TYPES, STATUSES } from './constants';
export { isAllowedOrigin } from './utils';
export { commsHandler } from './handlers';
//# sourceMappingURL=index.js.map